
import { defineComponent } from "vue";
import { GenericContent } from "@/services/paginator.service";
import Thumb from "@/common/Thumb.vue";
import { setPageDescription, setPageTitle } from "@/common/meta.utils";
import { titleFilter } from "@/common/title.filter";

export default defineComponent({
  name: "PageHeadline",
  components: { Thumb },
  props: {
    content: Object as () => GenericContent,
  },
  mounted() {
    this.setMeta();
  },
  watch: {
    content(content) {
      this.setMeta();
    },
  },
  methods: {
    setMeta() {
      setPageTitle(this.content?.title);
      setPageDescription(this.content?.lead);
    },

    titlePipe(title: string) {
      return titleFilter(title);
    },
  },
});
